"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var preview_full_size_view_1 = (0, tslib_1.__importDefault)(require("./preview-full-size.view"));
var PreviewFullsize = /** @class */ (function () {
    function PreviewFullsize(_a) {
        var previewService = _a.previewService, rootContainer = _a.rootContainer;
        this._previewService = previewService;
        this._initUI();
        this.hide();
        rootContainer.appendComponentElement(this.getElement());
    }
    PreviewFullsize.prototype._initUI = function () {
        this.view = new PreviewFullsize.View();
    };
    PreviewFullsize.prototype.getElement = function () {
        return this.view.getElement();
    };
    PreviewFullsize.prototype.showAt = function (second) {
        this.view.show();
        var framesData = this._previewService.getAt(second);
        if (!framesData) {
            this.view.clear();
            return;
        }
        var frameData = framesData.pop();
        if (this._currentFrame) {
            if (this._currentFrame.spriteUrl !== frameData.spriteUrl) {
                this.view.clear();
            }
        }
        this.view.setPreview(frameData);
        this._currentFrame = frameData;
    };
    PreviewFullsize.prototype.hide = function () {
        this.view.hide();
    };
    PreviewFullsize.prototype.destroy = function () {
        this.view.destroy();
    };
    PreviewFullsize.moduleName = 'previewFullSize';
    PreviewFullsize.View = preview_full_size_view_1.default;
    PreviewFullsize.dependencies = ['previewService', 'rootContainer'];
    return PreviewFullsize;
}());
exports.default = PreviewFullsize;
//# sourceMappingURL=preview-full-size.js.map